import { Login } from '../pages/Login/Login';
import { SandboxSignup } from '../pages/SandboxSignup/SandboxSignup';
import { RoutesType } from '../types/generalTypes';

const isSandbox = window._env_?.NODE_ENV === 'sandbox';

export const publicRoutes: RoutesType[] = [
	{
		name: 'login',
		path: '/login',
		showOnSidebar: false,
		element: <Login />,
	},
	// Sandbox signup route - only available in sandbox environment
	...(isSandbox
		? [
				{
					name: 'signup',
					path: '/signup',
					showOnSidebar: false,
					element: <SandboxSignup />,
				},
		  ]
		: []),
	{
		name: 'catchAll',
		path: '*',
		showOnSidebar: false,
		element: <Login />,
	},
];
